define(function (require) {

    // todo - require App!
    var App = window.App || {};

    var lpUtils = require('utils/lpUtils');
    var BaseFilterViewController = require('web-agent-viewControllers/BaseFilterViewController');
    var FilterItemMultiSelectionDropdownWithSearchViewController = require('web-agent-components/FilterItemMultiSelectionDropdownWithSearchViewController');
    var FilterDropdownSelectionViewController = BaseFilterViewController.extend({
        ControllerName: 'FilterDropdownSelectionViewController',
        LPViewMap: {
        },

    initialize: function (constructorData) {

        this.filterName = constructorData.filterName;
        this.filterTextSuffix = constructorData.filterTextSuffix;
        this.filterDataModelPath = constructorData.filterDataModelPath;
        this.textProperty = constructorData.textProperty || "name";
        this.publishProperty = constructorData.publishProperty || "id";
        this.toggleButton = constructorData.toggleButton;
        this.label = constructorData.label;

            if (constructorData.defaultFilter) {
                this.filterResetData = lpUtils.cloneObject(constructorData.defaultFilter);
                this.filterUIData = lpUtils.cloneObject(constructorData.defaultFilter);
                this.filterData = lpUtils.cloneObject(constructorData.defaultFilter);
            } else {
                this.filterResetData = null;
                this.filterUIData = null;
                this.filterData = null;
            }
            this.minusOneData = constructorData.minusOneData || null;

            this.initializeView();
        },
        events: function () {
        },
        render: function () {
        }
    });

    FilterDropdownSelectionViewController.prototype.initializeView = function () {
        // Add Dropdown
        this.DropdownVC = new FilterItemMultiSelectionDropdownWithSearchViewController({
            publishProperty: this.publishProperty,
            textProperty: this.textProperty,
            filterTextSuffix: this.filterTextSuffix,
            filterDataModelPath: this.filterDataModelPath,
            minusOneData: this.minusOneData,
            toggleButton: this.toggleButton,
            label: this.label
        });

        this.addViewController({viewController: this.DropdownVC, target: this.LPViewMap.filterArea});
    };

    // Check if the user click on one of the buttons (filter/reset/cancel) when closing the dropdown
    FilterDropdownSelectionViewController.prototype.onLostFocus = function (e) {
        this.setFocus();
        // Get the src element from the event data
        var src = e.toElement || e.relatedTarget || e.rangeParent || e.explicitOriginalTarget;
        if (src && src.nodeType === 3) { // 3= Represents textual content in an element or attribute, we need to get it's Element (his parent).
            src = src.parentElement;
        }
        if (this.getFirstElement(this.LPViewMap.filter_button) === src) {
            this.submitClick();
        } else if (this.getFirstElement(this.LPViewMap.reset_button) === src) {
            this.reset();
        } else if (this.getFirstElement(this.LPViewMap.cancel_button) === src) {
            this.cancel();
        }
    };

    FilterDropdownSelectionViewController.prototype.submitClick = function () {
        this.arrangeDataToSubmit();
        this.submitFilter();
    };

    FilterDropdownSelectionViewController.prototype.arrangeDataToSubmit = function () {
        this.filterUIData = this.DropdownVC.getValue() || "";
    };

// set the tags and dropdown according to the data in the filter
    FilterDropdownSelectionViewController.prototype.updateFilterUI = function () {
        this.DropdownVC.updateFilterUI(this.filterUIData);
    };

    return FilterDropdownSelectionViewController;

});
